// frontend/src/utils/phone.js

function onlyDigits(v = "") {
  return String(v || "").replace(/\D+/g, "");
}

function formatBrazilLocal(digits) {
  // digits: 10 (fixo) ou 11 (móvel) já sem DDI
  if (digits.length < 10) return digits; // fallback
  const ddd = digits.slice(0, 2);
  if (digits.length === 11) {
    // móvel: 2 + 5 + 4
    const a = digits.slice(2, 7);
    const b = digits.slice(7);
    return `${ddd} ${a}-${b}`;
  }
  // fixo: 2 + 4 + 4
  const a = digits.slice(2, 6);
  const b = digits.slice(6);
  return `${ddd} ${a}-${b}`;
}

/**
 * Formata UM telefone.
 * - Se começar com +55 ou 55, remove o DDI e formata como BR.
 * - Se vier 12/13 dígitos começando com 55, trata como BR.
 * - Se não for BR, mantém com +código do país e agrupa com espaços.
 */
export function formatPhone(raw) {
  if (!raw) return "";
  const s = String(raw).trim();

  // Já tem "+"?
  if (s.startsWith("+")) {
    const digits = onlyDigits(s);
    if (digits.startsWith("55")) {
      const local = digits.slice(2); // tira DDI
      if (local.length === 10 || local.length === 11) {
        return formatBrazilLocal(local);
      }
      // números atípicos: apenas devolve sem +55
      return formatBrazilLocal(local) || local;
    }
    // internacional (não BR): mantém +CC e agrupa restante
    const cc = digits.slice(0, 2); // heurística simples
    const rest = digits.slice(cc.length);
    // grupo em blocos 3-3-4 como aproximação
    const pretty = rest.replace(/(\d{3})(?=\d)/g, "$1 ").trim();
    return `+${cc} ${pretty}`.trim();
  }

  // Sem "+": pode vir com 55 no início ou só o nacional
  const digits = onlyDigits(s);
  if (digits.startsWith("55") && (digits.length === 12 || digits.length === 13)) {
    const local = digits.slice(2);
    return formatBrazilLocal(local);
  }

  // nacional "puro": 10 (fixo) ou 11 (móvel)
  if (digits.length === 10 || digits.length === 11) {
    return formatBrazilLocal(digits);
  }

  // fallback: devolve o que tiver (com pequenos espaços)
  return s.replace(/\s+/g, " ");
}

/**
 * Aceita lista de telefones no mesmo campo (separados por ; ou ,)
 * e formata cada um; remove duplicados e vazios.
 */
export function formatPhones(raw) {
  if (!raw) return "";
  const parts = String(raw)
    .split(/[;,]/)
    .map((x) => x.trim())
    .filter(Boolean);

  const formatted = parts.map((p) => formatPhone(p)).filter(Boolean);
  // remove duplicados mantendo ordem
  const seen = new Set();
  const uniq = [];
  for (const f of formatted) {
    if (!seen.has(f)) {
      seen.add(f);
      uniq.push(f);
    }
  }
  return uniq.join(" · ");
}
